import React from 'react'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'

class ConfirmationModal extends React.Component {
  handleClick = (test) => this.props.onConfirmation(test)

  render = () => (
    <Modal open={this.props.isOpen} basic size='small'>
      <Header>{this.props.question}</Header>
      <Modal.Actions>
        <Button onClick={this.handleClick.bind(this, false)} basic color='red' inverted>
          <Icon name='remove' /> No
        </Button>
        <Button onClick={this.handleClick.bind(this, true)} color='green' inverted>
          <Icon name='checkmark' /> Yes
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default ConfirmationModal


// WEBPACK FOOTER //
// ./src/component/modals/ConfirmationModal.js